import {useAgentInfo} from './use-agent-info'
import {isCopilotOrCustomAgent} from '../utils/agent-helpers'
import type {SelectedAgent} from '../types/session'

/**
 * Determines whether the model picker should be shown for the given agent.
 * Resolves the agent's slug (fetching agent info when the agent has a numeric
 * top-level id) and returns whether it is a Copilot or custom agent.
 */
export function useModelPickerEligibility(selectedAgent: SelectedAgent = {}): boolean {
  const parsedAgentId = selectedAgent.topLevelAgentId ? Number(selectedAgent.topLevelAgentId) : NaN
  const agentIdForFetch = Number.isFinite(parsedAgentId) ? parsedAgentId : null
  const {data: agentInfo} = useAgentInfo(agentIdForFetch)

  return isCopilotOrCustomAgent(selectedAgent, agentInfo?.slug)
}
